import { useMutation, useQueryClient } from "@tanstack/react-query";
import client from "../client";

/**
 * Forces a skip-cache recompute of the MarketingMetricsSnapshot for a
 * customer. Invalidates the cached Customer 360 query on success so the
 * page re-renders with fresh data.
 */
export function useRefreshMarketing(customerId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () =>
      client
        .post(`/admin/customers/${customerId}/marketing-metrics/refresh`)
        .then((r) => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["crm", "customer360", customerId] });
    },
  });
}
